import Vue from 'vue';
import Router from 'vue-router';
import store from '../store';
import cfg from '../store/config';
import {isActiveToken} from '@/mixins/auth';
import Login from "../views/Login/Login";
import Home from "../views/Home/Index";
import Deposits from "../views/Deposits/Deposits.vue";
import Withdraws from "../views/Withdraws/Withdraws.vue";
import Wallets from "../views/Wallets/Wallets.vue";
import AmlReports from "../views/Wallets/AmlReports.vue";
import Users from "../views/Users/List.vue";
import Settings from "../views/Settings/Settings.vue";


Vue.use(Router);

const ifAuthenticated = (to, from, next) => {
  const role = store.getters['user/getRole'];
  if (role && to.meta && to.meta.access) {
    const defaultRoute = '/orders';
    if (!to.meta.access.includes(role)) {
      next(defaultRoute);
      return;
    }
  }
  if (isActiveToken(store.getters['user/getToken'])) {
    next();
    return;
  }
  next('/login');
};

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      beforeEnter: ifAuthenticated,
      component: Home,
      children: [
        {
          path: '',
          beforeEnter: ifAuthenticated,
          component: Deposits,
          meta: {
            access: ['admin', 'superadmin', 'support', 'client'],
            title: 'Пополнения',
          }
        },
        {
          path: 'deposits',
          name: 'Deposits',
          beforeEnter: ifAuthenticated,
          component: Deposits,
          meta: {
            access: ['admin', 'superadmin', 'support', 'client'],
            title: 'Пополнения',
          }
        },
        {
          path: 'withdraws',
          name: 'Withdraws',
          beforeEnter: ifAuthenticated,
          component: Withdraws,
          meta: {
            access: ['admin', 'superadmin', 'support', 'client'],
            title: 'Выводы',
          }
        },
        {
          path: 'wallets',
          name: 'Wallets',
          beforeEnter: ifAuthenticated,
          component: Wallets,
          meta: {
            access: ['admin', 'superadmin', 'support', 'client'],
            title: 'Кошельки',
          }
        },
        {
          path: 'wallets/:address/aml-reports',
          name: 'AmlReports',
          beforeEnter: ifAuthenticated,
          component: AmlReports,
          meta: {
            access: ['superadmin'],
            menu: 'Wallets',
            title: 'История AML',
          }
        },
        {
          path: 'users',
          name: 'Users',
          beforeEnter: ifAuthenticated,
          component: Users,
          meta: {
            access: ['admin', 'superadmin'],
            title: 'Пользователи',
          }
        },
        {
          path: 'settings',
          name: 'Settings',
          beforeEnter: ifAuthenticated,
          component: Settings,
          meta: {
            access: ['superadmin'],
            title: 'Настройки',
          }
        },
      ],
    },
    {
      path: '/login',
      name: 'Login',
      component: Login,
      meta: {
        title: 'Авторизация',
      }
    },
  ],
});

let DEFAULT_TITLE = cfg.sitePrefix || '';
if (DEFAULT_TITLE) {
  DEFAULT_TITLE += ' - ';
}
router.afterEach((to, from) => {
  Vue.nextTick(() => {
    if (to.meta.title) {
      document.title = `${DEFAULT_TITLE}${to.meta.title}`;
    } else {
      if (DEFAULT_TITLE) {
        document.title = DEFAULT_TITLE;
      } else {
        document.title = 'Frontend';
      }
    }
  });
});

export default router;
